/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analyzing_Buyer_BehaviorInputs */

const en_analyzing_buyer_behavior = /** @type {(inputs: Analyzing_Buyer_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing buyer behavior...`)
};

const es_analyzing_buyer_behavior = /** @type {(inputs: Analyzing_Buyer_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizando el comportamiento del comprador...`)
};

const fr_analyzing_buyer_behavior = /** @type {(inputs: Analyzing_Buyer_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse du comportement des acheteurs...`)
};

const de_analyzing_buyer_behavior = /** @type {(inputs: Analyzing_Buyer_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käuferverhalten wird analysiert...`)
};

const ja_analyzing_buyer_behavior = /** @type {(inputs: Analyzing_Buyer_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入者の行動を分析中...`)
};

const zh_analyzing_buyer_behavior = /** @type {(inputs: Analyzing_Buyer_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在分析买家行为...`)
};

const ar_analyzing_buyer_behavior = /** @type {(inputs: Analyzing_Buyer_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاري تحليل سلوك المشتري...`)
};

const id_analyzing_buyer_behavior = /** @type {(inputs: Analyzing_Buyer_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menganalisis perilaku pembeli...`)
};

const it_analyzing_buyer_behavior = /** @type {(inputs: Analyzing_Buyer_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi del comportamento dell'acquirente in corso...`)
};

const ru_analyzing_buyer_behavior = /** @type {(inputs: Analyzing_Buyer_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Анализ поведения покупателей...`)
};

const pt_analyzing_buyer_behavior = /** @type {(inputs: Analyzing_Buyer_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisando o comportamento do comprador...`)
};

const ko_analyzing_buyer_behavior = /** @type {(inputs: Analyzing_Buyer_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구매자 행동을 분석하는 중...`)
};

/**
* | output |
* | --- |
* | "Analyzing buyer behavior..." |
*
* @param {Analyzing_Buyer_BehaviorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const analyzing_buyer_behavior = /** @type {((inputs?: Analyzing_Buyer_BehaviorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analyzing_Buyer_BehaviorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_analyzing_buyer_behavior(inputs)
	if (locale === "es") return es_analyzing_buyer_behavior(inputs)
	if (locale === "fr") return fr_analyzing_buyer_behavior(inputs)
	if (locale === "de") return de_analyzing_buyer_behavior(inputs)
	if (locale === "ja") return ja_analyzing_buyer_behavior(inputs)
	if (locale === "zh") return zh_analyzing_buyer_behavior(inputs)
	if (locale === "ar") return ar_analyzing_buyer_behavior(inputs)
	if (locale === "id") return id_analyzing_buyer_behavior(inputs)
	if (locale === "it") return it_analyzing_buyer_behavior(inputs)
	if (locale === "ru") return ru_analyzing_buyer_behavior(inputs)
	if (locale === "pt") return pt_analyzing_buyer_behavior(inputs)
	return ko_analyzing_buyer_behavior(inputs)
});